var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 0H6.75V1.5H5.25V3H6.75V1.5H12.75V3H14.25V1.5H12.75V0ZM6.75 4.5H8.25V6H6.75V4.5ZM11.25 4.5V3H8.25V4.5H11.25ZM11.25 4.5H12.75V6H11.25V4.5ZM10.5 6H9V7.5H0V15H15V7.5H10.5V6ZM13.5 9V13.5H1.5V9H13.5ZM12 10.5H10.5V12H12V10.5ZM7.5 10.5H9V12H7.5V10.5Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModem);
export default __webpack_public_path__ + "static/media/Modem.634c155ddf2c653b02d517e7a52c15aa.svg";
export { ForwardRef as ReactComponent };